export function round2(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export function clampPercent(value: number): number {
  if (!Number.isFinite(value)) return 0
  return Math.min(100, Math.max(0, value))
}

export function safeNumber(value: number | undefined | null, fallback = 0): number {
  if (value == null || !Number.isFinite(value)) return fallback
  return value
}
